<script setup lang="ts">
import PageHeader from "./components/PageHeader.vue";
import Footer from "@persolog/ui/Footer.vue";
</script>

<template>
    <PageHeader />
    <!-- One toast outlet for the whole app: mounting it per view meant some pages could raise a
         toast and others silently could not. -->
    <Toast />
    <main class="centered">
        <router-view></router-view>
    </main>
    <div class="footer-spacing">
        <Footer />
    </div>
</template>

<style scoped>
.centered {
    margin-left: 10%;
    margin-right: 10%;
    min-height: 40vh;
}

/* preserve the top spacing the old PageFooter had via its .moved-down margin */
.footer-spacing {
    margin-top: 10%;
}
</style>

<style>
/* Global light blue background for entire application */
body {
    background-color: #fafbff !important;
    min-height: 100vh;
}

html, #app {
    background-color: #fafbff;
    min-height: 100vh;
}
</style>
